import Lottie from "lottie-react";
import ReactPortal from "../../../ReactPortal/ReactPortal";
import Overlay from "../../OverLay/OverLay";
import LoadingAnimationData from "../../../../assets/lotties/loading.json";
import classes from "./LoadingOverlay.module.css";

const LoadingOverlay = () => {
  return (
    <ReactPortal wrapperId="loading-overlay">
      <Overlay />
      <div className={classes["loading-container"]}>
        <Lottie
          animationData={LoadingAnimationData}
          className={classes["loading"]}
        />
      </div>
    </ReactPortal>
  );
};

export default LoadingOverlay;
